// Module
var code = "<a ng-click=\"vm.printSummary()\"> <i class=\"fa fa-print fa-fw\"></i> Print Summary </a> ";
// Exports
module.exports = code;